import { PublicKey } from '@solana/web3.js';
import { useMemo } from 'react';
import { usePrivyEmbeddedWallet } from '../usePrivyEmbeddedWallet';
import { usePrivyWalletMapping } from './usePrivyWalletMapping';
import useCurrentAuthority from 'src/hooks/useCurrentAuthority';

/**
 * Hook that returns the embedded wallet for the current authority.
 * If the embedded wallet is not found, it returns the embedded wallet from the database.
 * IMPORTANT: This should not be used as the source of truth for the embedded wallet, and more
 * for display purposes only.
 */
export const usePrivyEmbeddedWalletWithFallback = () => {
	const { embeddedWallet: embeddedWalletFromPrivy } = usePrivyEmbeddedWallet();
	const currentAuthority = useCurrentAuthority();

	const embeddedWalletMapping =
		usePrivyWalletMapping(currentAuthority).data?.embeddedWallet;

	const embeddedWallet = useMemo(() => {
		if (!embeddedWalletFromPrivy)
			return embeddedWalletMapping
				? new PublicKey(embeddedWalletMapping)
				: null;
		return new PublicKey(embeddedWalletFromPrivy.address);
	}, [embeddedWalletFromPrivy, embeddedWalletMapping]);

	return embeddedWallet;
};
